import styled from 'styled-components/macro';

const NavWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default NavWrapper;
